/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Description1Inputs */

const en_usermanagement_permissions_description1 = /** @type {(inputs: Usermanagement_Permissions_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage users access and set roles. You are able
 to control permissions based on the role selected.`)
};

/**
* | output |
* | --- |
* | "Manage users access and set roles. You are able to control permissions based on the role selected." |
*
* @param {Usermanagement_Permissions_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_description1 = /** @type {((inputs?: Usermanagement_Permissions_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_description1(inputs)
});
export { usermanagement_permissions_description1 as "userManagement_permissions_description" }